import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { RefineryBalanceService } from "../refinery-balance.service";
import { DxDataGridComponent } from "devextreme-angular";
import { Router } from "@angular/router";

@Component({
    selector: 'refinery-balance-by-site',
    templateUrl: './refinery-balance-by-site.component.html',
    styleUrls: ['./refinery-balance-by-site.component.scss']
})

export class RefineryBalanceBySiteComponent implements OnInit {

    siteId: number;
    siteName: string;
    countryName: string;
    province: string;
    city: string;
    latitude: any;
    longitude: any;
    currentDate: Date = new Date();
    refineryBalancesBySite: any[];
    isLoadPanelVisible: boolean = false;
    refiningSiteProductionFacilityPipelineSummary: any[];
    siteComment: any;
    @ViewChild("RefineryBalanceGrid", { static: false }) RefineryBalanceGrid: DxDataGridComponent;
    @ViewChild("RefiningSiteProductionFacilityPipelineSummaryGrid", { static: false }) RefiningSiteProductionFacilityPipelineSummaryGrid: DxDataGridComponent;
    H2VolumeNetSum: number = 0;
    O2VolumeNetSum: number = 0;
    netSurplusData: { netSurplus: string, h2NetSurplus: number, o2NetSurplus: number }[] = [{ netSurplus: "Net Surplus", h2NetSurplus: 0, o2NetSurplus: 0 }];

    constructor(private notificationService: NotificationService, private route: ActivatedRoute, private refineryBalanceService: RefineryBalanceService, private router: Router) {
        this.getH2Total = this.getH2Total.bind(this);
        this.getO2Total = this.getO2Total.bind(this);
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params['siteId']) {
                this.siteId = params['siteId'];

                this.isLoadPanelVisible = true;
                this.refineryBalanceService.GetRefineryBalancesBySite(this.siteId).subscribe({
                    next: refineryBalances => {
                        if (refineryBalances.length > 0) {
                            this.siteName = refineryBalances[0].companyName;
                            this.countryName = refineryBalances[0].countryName;
                            this.province = refineryBalances[0].province;
                            this.city = refineryBalances[0].city;
                            this.latitude = refineryBalances[0].latitude;
                            this.longitude = refineryBalances[0].longitude;
                            this.siteComment = refineryBalances[0].comment
                        }

                        this.refineryBalancesBySite = refineryBalances;

                        this.isLoadPanelVisible = false;
                    }, error: (error: any) => {
                        this.isLoadPanelVisible = false;
                        this.notificationService.alert("error", "Error while fetching Refinery Balances", error);
                    }
                });

                this.refineryBalanceService.GetRefiningSiteProductionFacilityPipelineSummary(this.siteId).subscribe({
                    next: refineryBalances => {
                        this.refiningSiteProductionFacilityPipelineSummary = refineryBalances;

                        this.isLoadPanelVisible = false;
                    }, error: (error: any) => {
                        this.isLoadPanelVisible = false;
                        this.notificationService.alert("error", "Error while fetching Site ProductionFacility Pipeline Summary", error);
                    }
                });
            }
        })
    }

    getH2Total(arg) {
        this.netSurplusData[0].h2NetSurplus += arg.value;
        return arg.value.toFixed(4);;
    }

    getO2Total(arg) {
        this.netSurplusData[0].o2NetSurplus += arg.value;
        return arg.value.toFixed(4);
    }

    getSumValueOnly(arg) {
        return arg.value.toFixed(4);
    }

    getLabel(arg) {
        return "Total";
    }

    onBackbtnClicked(e) {
        this.router.navigate(['/refinerybalance']);
    }
}